module.exports = __webpack_public_path__ + "static/Health0-c1c0357c192ac9aada7e3a47c6b21a65.png";